import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-flow-limit-temp-confirmation-dialog',
  templateUrl: './flow-limit-temp-confirmation-dialog.component.html',
  styleUrls: ['./flow-limit-temp-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowLimitTempConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<FlowLimitTempConfirmationDialogComponent>,
    private installationFeaturesStore: InstallationFeaturesStore,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close({ cancel: true });
  }

  onConfirm(): void {
    this.installationFeaturesStore.updateFeature(
      this.data.url,
      this.data.value,
      'max',
      'temperature',
      'setMax'
    );
    this.dialogRef.close({ cancel: false });
  }
}
